/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

export function toggle_edit_mode(force = undefined) {
    if (typeof force === "undefined") {
        force = !this._is_edit_mode;
    }

    this._is_edit_mode = force;
    this.classList.toggle("editable", force);
    if (this._edit_mode !== undefined) {
        this._edit_mode.classList.toggle("editable", force);
        if (force) {
            this._edit_mode.children[0].textContent = "Editable";
        } else {
            this._edit_mode.children[0].textContent = "Read Only";
        }
    }
}

export function toggle_scroll_lock(force = undefined) {
    if (typeof force === "undefined") {
        force = !this._is_scroll_lock;
    }

    this._is_scroll_lock = force;
    this.classList.toggle("sub-cell-scroll-disabled", force);
    if (this._scroll_lock !== undefined) {
        this._scroll_lock.classList.toggle("lock-scroll", force);
        if (!force) {
            this._scroll_lock.children[0].textContent = "Free Scroll";
        } else {
            this._scroll_lock.children[0].textContent = "Align Scroll";
        }
    }
}
